<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-login></app-breadcrumb-login>
    <app-login-section></app-login-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
